/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class SupportAssistApi {
  async GetTicketGU(ticketNumber : string) : Promise<string> {
    return await componentApi.call('st', 'st-support-assist', 'SupportAssistApi', 'GetTicketGU', {
      ticketNumber,
    });
  }
  async Prompt(text : string, excludeSensitiveData : boolean) : Promise<st.SupportResponse> {
    return await componentApi.call('st', 'st-support-assist', 'SupportAssistApi', 'Prompt', {
      text,
      excludeSensitiveData,
    });
  }
  async SetUserRating(aiLogGU : string, isHelpful : boolean) : Promise<any> {
    return await componentApi.call('st', 'st-support-assist', 'SupportAssistApi', 'SetUserRating', {
      aiLogGU,
      isHelpful,
    });
  }
  async GetPresignedUrl(f : string) : Promise<string> {
    return await componentApi.call('st', 'st-support-assist', 'SupportAssistApi', 'GetPresignedUrl', {
      f,
    });
  }
}
export default new SupportAssistApi()
